import { render, staticRenderFns } from "./MypageFavoritePlayerSelectPage.vue?vue&type=template&id=2fe9fe6c"
import script from "./MypageFavoritePlayerSelectPage.vue?vue&type=script&lang=ts"
export * from "./MypageFavoritePlayerSelectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports